/**
 * @file Dashboard.style.js
 * Exports Dashboard page styles.
 */

export default theme => ({
  card: {
    marginTop: theme.spacing.unit * 2
  },
  buttons: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2
  },
  buttonIcon: {
    marginLeft: theme.spacing.unit
  },
  cardActionButton: {
    marginRight: theme.spacing.unit
  }
});



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.style.js